var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgResume = function SvgResume(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#4ECDC4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M5.833 30V11.667C5.833 5 7.5 3.334 14.168 3.334h11.667c6.666 0 8.333 1.666 8.333 8.333v16.666c0 .234 0 .467-.017.7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#403F3F",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M10.584 25h23.583v5.833a5.84 5.84 0 0 1-5.834 5.834H11.668a5.84 5.84 0 0 1-5.833-5.834V29.75a4.759 4.759 0 0 1 4.75-4.75Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#4ECDC4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M13.334 11.666h13.333M13.334 17.5h8.333"
  })));
};
export default SvgResume;